/*global angular*/
module.exports = [function () {
  'use strict';
  return {
    restrict: 'E',
    template: require('./video.html'),
    replace: true,
    transclude: true,
    scope: {
      content: '=data'
    },
    link: function (scope) {
      if(scope.content) {
        const url = scope.content.attachments.filter(o => o.type === 'VIDEO')[0].playbackUrl;
        if (url !== undefined && url != '') {
          var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
          var match = url.match(regExp);
          if (match && match[2].length === 11) {
            scope.playbackUrl = 'https://youtube.com/embed/' + match[2];
          }
        }
      }
    }
  };
}];




// WEBPACK FOOTER //
// ./web/js/module/practicalExample/js/video/video.js